<div class="container" style="padding-left: 0px !important;">
  <div class="row">
    <div class="col-12">
      <!-- <div class="home-page-content">

      </div> -->
      <div class="text-center home-image">
        <!-- <img src="/assets/images/home4_1200.png" alt="Fabrics Image" /> -->
         <img src="/assets/images/45yr_banner.jpg" alt="Fabrics Image" />
        &nbsp;
      </div>
    </div>
  </div>

  <!-- <div class="row welcome-video-container">
    <div class="col-12">
     <div class="text-center">
       <iframe width="560" height="315" src="https://www.youtube.com/embed/atETpd29lqU?si=L-QW2JmyDcnt2eMf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  </div> 
</div> -->

  <div class="row welcome-video-container">
    <div class="col-12">
     <div class="text-center">
      <!-- <iframe src="https://www.youtube.com/embed/8xkm9NXCeYk?si=b-eyQBwka5C07LlY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
      <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/br9eeGFEmYA?si=Sw57P0D-TCK5Gt7a" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
       <!-- <iframe width="560" height="315" src="https://youtube.com/embed/TJ3rygoPWlA?si=ICfCiq7wfAgl3m6z" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
        <iframe width="560" height="315" src="https://www.youtube.com/embed/vV-3T8N3wE4?si=AB0MneoAl3qRyK3j" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>

<div class="container featured-section">
  <div class="row">
    <div class="col-12">
      <div class="featured-section-title">
        Featured Products
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="featured-product">
        <img src="/assets/images/b26.png" alt="btsk" class="featured" /><br />
        <p class="featured-product-title">Basic Textiles Swatch Kit</p>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="featured-product2">
        <img src="/assets/images/textilepedia.png" alt="textilepedia" class="featured" /><br/>
        <p class="featured-product-title">Textilepedia</p>
      </div>
      
    </div>
    <div class="col-12 single-featured">
      <div class="featured-product3">
        <img src="/assets/images/yarn_count.png" alt="yarn" class="featured" />
        <p class="featured-product-title">Learn How To Perform A Yarn/Fiber Count</p>
        <p>For more content like this, subscribe to our Youtube channel!</p>
      </div>
    </div>

  </div>
  
</div>